import { inject } from '@angular/core';
import { CenterApiService } from '@shared/services';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const centerTableConfig = (): TableConfig => {
  const centerApiService = inject(CenterApiService);

  return {
    title: 'Quản lý trung tâm',
    entityName: 'trung tâm',
    service: centerApiService,
    method: 'getCenters',
    columns: [
      { field: 'code', header: 'Mã trung tâm', width: 'min-w-[100px]', sortable: true, type: 'tag', tagColor: 'tagColor', tagTextColor: 'tagTextColor' },
      { field: 'name', header: 'Tên trung tâm', width: 'min-w-[200px]', sortable: true, type: 'text' },
      { field: 'cluster.name', header: 'Cụm', width: 'min-w-[80px]', sortable: true, type: 'tag' },
      { field: 'phone', header: 'Số ĐT', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'address', header: 'Địa chỉ', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'gMapLink', header: 'Link GMap', width: 'min-w-[100px]', sortable: true, type: 'link', linkText: 'Link'},
      { field: 'tagColor', header: 'Màu thẻ', width: 'min-w-[80px]', sortable: false, type: 'color' },
      { field: 'tagTextColor', header: 'Màu chữ', width: 'min-w-[80px]', sortable: false, type: 'color' },
      { field: 'active', header: 'Hoạt động?', width: 'min-w-[100px]', sortable: true, type: 'boolean' },
      { field: 'lat', header: 'Kinh độ', width: 'min-w-[100px]', sortable: true, type: 'text'},
      { field: 'lng', header: 'Vĩ độ', width: 'min-w-[100px]', sortable: true, type: 'text'}
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};
